export default __webpack_public_path__ + "images/multilang-offer-step-2_2x.d0f205b97d9b52fe471c3bd4cdc71788.png";